import {
  LoyaltyOfferCardButton,
  LoyaltyOfferCardContainer,
  LoyaltyOfferCardContentContainer,
  LoyaltyOfferCardDetailsModal,
  LoyaltyOfferCardFloatingLabel,
  LoyaltyOfferCardFooter,
  LoyaltyOfferCardImage,
  LoyaltyOfferCardLabel,
  LoyaltyOfferCardPressableText,
  LoyaltyOfferCardProgressBar,
  LoyaltyOfferCardTag,
  LoyaltyOfferCardText,
  LoyaltyOfferCardTitle,
} from './components';

export const LoyaltyOfferCard = {
  Container: LoyaltyOfferCardContainer,
  ContentContainer: LoyaltyOfferCardContentContainer,
  Image: LoyaltyOfferCardImage,
  Tag: LoyaltyOfferCardTag,
  Label: LoyaltyOfferCardLabel,
  FloatingLabel: LoyaltyOfferCardFloatingLabel,
  Title: LoyaltyOfferCardTitle,
  Text: LoyaltyOfferCardText,
  PressableText: LoyaltyOfferCardPressableText,
  Button: LoyaltyOfferCardButton,
  ProgressBar: LoyaltyOfferCardProgressBar,
  Footer: LoyaltyOfferCardFooter,
  DetailsModal: LoyaltyOfferCardDetailsModal,
};
